import hFullLoad from './src/h-fullLoad.vue'

hFullLoad.install = function (Vue) {
  Vue.component(hFullLoad.name, hFullLoad);
};

export default hFullLoad;